import * as React from "react";
import { useSelector } from "react-redux";
import MarkdownRenderer from "../../../../components/MarkdownRenderer";
import { selectArchiveTerms } from "../../../../store/selectors/DataSelectors";

const ArchiveOrderDetails = () => {
  const terms = useSelector(selectArchiveTerms);

  return <MarkdownRenderer source={terms} />
}

export default ArchiveOrderDetails;
